import React, { useEffect, useState } from 'react';
export const MobileStoreButton = () => {
  const [isVisible, setIsVisible] = useState(true);
  useEffect(() => {
    // Create an Intersection Observer to detect when the CTA button is visible
    const observer = new IntersectionObserver(entries => {
      // When the CTA button is visible, hide the mobile button
      if (entries[0].isIntersecting) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
    }, {
      threshold: 0.1
    }) // Trigger when at least 10% of the target is visible
    ;
    // Target the shop collection button in the mission section
    const targetButton = document.querySelector('.mission-cta');
    if (targetButton) {
      observer.observe(targetButton);
    }
    return () => {
      if (targetButton) {
        observer.unobserve(targetButton);
      }
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 p-4 bg-white border-t border-gray-200 md:hidden" data-id="element-23">
      <a href="https://frznjewelry.co" target="_blank" rel="noopener noreferrer" className="block bg-black text-white font-bold text-center py-3 rounded-full shadow-lg hover:bg-gray-800 transition-colors" data-id="element-24">
        VISIT OUR STORE
      </a>
    </div>;
};